__turbopack_context__.v({
  "bgGradient": "oSsljq_bgGradient",
  "container": "oSsljq_container",
  "content": "oSsljq_content",
  "cta": "oSsljq_cta",
  "highlight": "oSsljq_highlight",
  "phoneContainer": "oSsljq_phoneContainer",
  "phoneSvgContainer": "oSsljq_phoneSvgContainer",
  "playPauseBg": "oSsljq_playPauseBg",
  "playPauseContainer": "oSsljq_playPauseContainer",
  "playPauseIcon": "oSsljq_playPauseIcon",
  "section": "oSsljq_section",
  "subtitle": "oSsljq_subtitle",
  "title": "oSsljq_title",
  "videoOverlay": "oSsljq_videoOverlay",
  "videoSectionsContainer": "oSsljq_videoSectionsContainer",
});
